export default "__VITE_ASSET__BXUaAeLj__"